var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScannerPro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "270px",
    viewBox: "0 0 360 270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-rtn-16ycy3-1",
    x: 0,
    y: 0,
    width: 360,
    height: 270
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00320794797%",
    y1: "50%",
    x2: "100.109072%",
    y2: "50%",
    id: "linearGradient-rtn-16ycy3-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FF",
    offset: "20.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DEFF",
    offset: "54.93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5B6FF",
    offset: "97.69%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3B4FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing_03",
    transform: "translate(-1250.000000, -3330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portfolio_01",
    transform: "translate(-150.000000, 3000.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "002-2",
    transform: "translate(1400.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-rtn-16ycy3-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-rtn-16ycy3-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#DCDCDE",
    xlinkHref: "#path-rtn-16ycy3-1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EBEBED",
    cx: 1580,
    cy: 465,
    r: 70
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(1555.000000, 440.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,50 L12,50 C5.4,50 0,44.6 0,38 L0,12 C0,5.4 5.4,0 12,0 L38,0 C44.6,0 50,5.4 50,12 L50,38 C50,44.6 44.6,50 38,50 Z",
    id: "Path",
    fill: "#5313AD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,41 L14,41 C13,41 12.2,40.1 12.3,39 L15.7,18.4 C15.8,17.6 16.5,17 17.4,17 L32.5,17 C33.3,17 34,17.6 34.2,18.4 L37.6,39 C37.8,40.1 37,41 36,41 Z",
    id: "Path",
    fill: "#E6FFFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4,33 L10.6,33 C9.3,33 8.5,31.7 8.9,30.6 L13.6,18.2 C13.9,17.5 14.5,17 15.3,17 L34.8,17 C35.5,17 36.2,17.5 36.5,18.2 L41.2,30.6 C41.5,31.7 40.7,33 39.4,33 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,25 L8.4,25 C6.9,25 5.9,23.4 6.7,22 L13.4,10 C13.8,9.4 14.4,9 15.1,9 L34.8,9 C35.5,9 36.2,9.4 36.5,10 L43.2,22 C44.1,23.4 43.1,25 41.6,25 Z",
    id: "Path",
    fill: "url(#linearGradient-rtn-16ycy3-3)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannerPro);
export default __webpack_public_path__ + "static/media/scannerPro.aea1a12ad8b05c34dab46daa16ea6345.svg";
export { ForwardRef as ReactComponent };